var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "doc-wrapper" }, [
    _c("iframe", {
      staticClass: "allScreen",
      attrs: { frameborder: "0", src: _vm.attachmentUrl },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }